import React, { useState } from 'react'
import styled from 'styled-components'
import { PoliciesDataTable } from '../Components/Policies/PoliciesDataTable'
import { PoliciesFirst } from '../Components/Policies/PoliciesFirst'
import { useGetAllPolicyQuery } from '../features/policySlice'
import { tokens } from '../Shared/tokens'

/**
 * Owns the policy list and the filter state.
 *
 * Both live here so the filter bar in the header can actually drive the grid
 * below it — previously the header rendered inert selects and the grid fetched
 * its own copy of the data.
 */
export const PoliciesComponent = () => {
  const [filters, setFilters] = useState({ query: '', year: '' })
  const { data: policies, isLoading } = useGetAllPolicyQuery()

  return (
    <Main>
      <Content>
        <PoliciesFirst
          filters={filters}
          onFiltersChange={setFilters}
          policies={policies ?? []}
        />
        <PoliciesDataTable
          policies={policies ?? []}
          isLoading={isLoading}
          filters={filters}
        />
      </Content>
    </Main>
  )
}

const Main = styled.div`
  background-color: ${tokens.color.canvas};
  min-height: calc(100vh - 10vh);
  margin-top: 10vh;
  padding: ${tokens.space.xl};
`

/* Was a fixed 90% width centred with flex, which drifted wider than the
   readable range on large monitors. */
const Content = styled.div`
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: ${tokens.space.xl};

  @media (max-width: 640px) {
    gap: ${tokens.space.lg};
  }
`
